import { render, staticRenderFns } from "./saleInvoiceApproval.vue?vue&type=template&id=badbc148&scoped=true"
import script from "./saleInvoiceApproval.vue?vue&type=script&lang=js"
export * from "./saleInvoiceApproval.vue?vue&type=script&lang=js"
import style0 from "./saleInvoiceApproval.vue?vue&type=style&index=0&id=badbc148&prod&lang=css"
import style1 from "./saleInvoiceApproval.vue?vue&type=style&index=1&id=badbc148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badbc148",
  null
  
)

export default component.exports